import {GenerateDocumentContentMessage} from 'notebook/ai-tools/NotebookAIToolsConstants';
import * as TaskRunner from 'util/TaskRunner';

interface GenerateDocumentContentResponse {
  message: GenerateDocumentContentMessage;
}

interface GenerateDocumentContentResponse {
  message: GenerateDocumentContentMessage;
}

export function generateDocumentContent(
  entryId: string,
  fileS3Locations: Array<string>,
  userPrompt: string,
  notePartIndex: number
): Promise<GenerateDocumentContentResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/notebook/ai-tools:generate-document-content',
    data: {entryId, fileS3Locations, userPrompt, notePartIndex},
  });
}

export interface CheckEntryUsingAIResponse {
  traceId: string;
  checkResults: Array<{text: string}>;
  hadError: boolean;
}

export function checkEntryUsingAI(entryId: string): Promise<CheckEntryUsingAIResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/notebook/ai-tools:check-entry',
    data: {entryId},
  });
}

export interface FillStructuredTableUsingAIResponse {
  newRows: Array<Array<{text: string}>>;
  hadError: boolean;
}

export function fillStructuredTableUsingAI(
  entryId: string,
  tableName: string,
  fileS3Locations: Array<string>,
  userPrompt: string
): Promise<FillStructuredTableUsingAIResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/notebook/ai-tools:fill-structured-table',
    data: {entryId, tableName, fileS3Locations, userPrompt},
  });
}
